import countries from 'i18n-iso-countries';

import en from 'i18n-iso-countries/langs/en.json';
import pl from 'i18n-iso-countries/langs/pl.json';

export const i18nCountryNames = () => {
    countries.registerLocale(en);
    countries.registerLocale(pl);
}